import Outdoors from '@/views/Outdoors/Index'
import OutdoorsSettings from '@/views/Outdoors/Settings/Index'
import OutdoorsSettingsOutdoorsLocalizations from '@/views/Outdoors/Settings/OutdoorsLocalizations/Index'
import OutdoorsSettingsOutdoorsLocalizationsOutdoorsLocalization from '@/views/Outdoors/Settings/OutdoorsLocalizations/OutdoorsLocalization'
import OutdoorsSettingsOutdoorsTeams from '@/views/Outdoors/Settings/OutdoorsTeams/Index'
import OutdoorsSettingsOutdoorsTeamsOutdoorsTeam from '@/views/Outdoors/Settings/OutdoorsTeams/OutdoorsTeam'
import OutdoorsSettingsOutdoorsContractors from '@/views/Outdoors/Settings/OutdoorsContractors/Index'
import OutdoorsSettingsOutdoorsContractorsOutdoorsContractor from '@/views/Outdoors/Settings/OutdoorsContractors/OutdoorsContractor'
import OutdoorsCampaigns from '@/views/Outdoors/Campaigns/Index'
import OutdoorsCampaignsCampaigns from '@/views/Outdoors/Campaigns/Campaigns/Index'
import OutdoorsCampaignsCampaignsOutdoorsCampaign from '@/views/Outdoors/Campaigns/Campaigns/OutdoorsCampaign'
import OutdoorsCampaignsCampaignsProduct from '@/views/Outdoors/Campaigns/Campaigns/Product'
import OutdoorsMap from '@/views/Outdoors/Map/Index'
import OutdoorsBBTracking from '@/views/Outdoors/BBTracking/Index'
import OutdoorsBBTrackingBBTracking from '@/views/Outdoors/BBTracking/BBTracking/Index'

export default [
    {
        path: '/outdoors',
        name: 'outdoors',
        component: Outdoors,
        meta: {
            title: 'Outdoors',
            menuRendered: true,
            menuTitle: 'Outdoors',
            permission: 'outdoors',
            icon: 'mdi-walk'
        },
        children: [
            {
                path: '/outdoors/settings',
                name: 'outdoorsSettings',
                component: OutdoorsSettings,
                meta: {
                    title: 'Outdoors / Ustawienia',
                    menuRendered: true,
                    menuTitle: 'Ustawienia',
                    requiresAuth: true,
                    permission: 'outdoors',
                },
                redirect: { name: 'outdoorsSettingsOutdoorsLocalizations' },
                children: [
                    {
                        path: '/outdoors/settings/outdoors-localizations',
                        name: 'outdoorsSettingsOutdoorsLocalizations',
                        component: OutdoorsSettingsOutdoorsLocalizations,
                        meta: {
                            title: 'Outdoors / Ustawienia / Lokalizacje',
                            requiresAuth: true,
                            permission: 'outdoors',
                        },
                    },
                    {
                        path: '/outdoors/settings/outdoors-localizations/create',
                        name: 'outdoorsSettingsOutdoorsLocalizationsOutdoorsLocalizationCreate',
                        component: OutdoorsSettingsOutdoorsLocalizationsOutdoorsLocalization,
                        meta: {
                            title: 'Outdoors / Ustawienia / Lokalizacje / Nowa lokalizacja',
                            requiresAuth: true,
                            permission:  'outdoors_create'
                        },
                    },
                    {
                        path: '/outdoors/settings/outdoors-localizations/edit/:id',
                        name: 'outdoorsSettingsOutdoorsLocalizationsOutdoorsLocalizationEdit',
                        component: OutdoorsSettingsOutdoorsLocalizationsOutdoorsLocalization,
                        meta: {
                            title: 'Outdoors / Ustawienia / Lokalizacje / Lokalizacja',
                            requiresAuth: true,
                            permission:  'outdoors_read'
                        },
                    },
                    {
                        path: '/outdoors/settings/outdoors-teams',
                        name: 'outdoorsSettingsOutdoorsTeams',
                        component: OutdoorsSettingsOutdoorsTeams,
                        meta: {
                            title: 'Outdoors / Ustawienia / Ekipy',
                            requiresAuth: true,
                            permission: 'outdoors_read',
                        }
                    },
                    {
                        path: '/outdoors/settings/outdoors-teams/create',
                        name: 'outdoorsSettingsOutdoorsTeamsOutdoorsTeamCreate',
                        component: OutdoorsSettingsOutdoorsTeamsOutdoorsTeam,
                        meta: {
                            title: 'Outdoors / Ustawienia / Ekipy / Nowa ekipa',
                            requiresAuth: true,
                            permission:  'outdoors_create'
                        },
                    },
                    {
                        path: '/outdoors/settings/outdoors-teams/edit/:id',
                        name: 'outdoorsSettingsOutdoorsTeamsOutdoorsTeamEdit',
                        component: OutdoorsSettingsOutdoorsTeamsOutdoorsTeam,
                        meta: {
                            title: 'Outdoors / Ustawienia / Ekipy / Ekipa',
                            requiresAuth: true,
                            permission:  'outdoors_read'
                        },
                    },
                    {
                        path: '/outdoors/settings/outdoors-contractors',
                        name: 'outdoorsSettingsOutdoorsContractors',
                        component: OutdoorsSettingsOutdoorsContractors,
                        meta: {
                            title: 'Outdoors / Ustawienia / Zleceniobiorcy',
                            requiresAuth: true,
                            permission: 'outdoors_read',
                        }
                    },
                    {
                        path: '/outdoors/settings/outdoors-contractors/create',
                        name: 'outdoorsSettingsOutdoorsContractorsOutdoorsContractorCreate',
                        component: OutdoorsSettingsOutdoorsContractorsOutdoorsContractor,
                        meta: {
                            title: 'Outdoors / Ustawienia / Zleceniobiorcy / Nowy zleceniobiorca',
                            requiresAuth: true,
                            permission:  'outdoors_create'
                        },
                    },
                    {
                        path: '/outdoors/settings/outdoors-contractors/edit/:id',
                        name: 'outdoorsSettingsOutdoorsContractorsOutdoorsContractorEdit',
                        component: OutdoorsSettingsOutdoorsContractorsOutdoorsContractor,
                        meta: {
                            title: 'Outdoors / Ustawienia / Zleceniobiorcy / Zleceniobiorca',
                            requiresAuth: true,
                            permission:  'outdoors_read'
                        },
                    },
                ],
            },
            {
                path: '/outdoors/bb-tracking',
                name: 'outdoorsBBTracking',
                component: OutdoorsBBTracking,
                meta: {
                    title: 'Outdoors / Grupy nośników BB',
                    menuRendered: true,
                    menuTitle: 'Grupy nośników BB',
                    requiresAuth: true,
                    permission: 'outdoors',
                },
                redirect: { name: 'outdoorsBBTrackingBBTracking' },
                children: [
                    {
                        path: '/outdoors/bb-tracking/bb-tracking',
                        name: 'outdoorsBBTrackingBBTracking',
                        component: OutdoorsBBTrackingBBTracking,
                        meta: {
                            title: 'Outdoors / Grupy nośników BB',
                            requiresAuth: true,
                            permission: 'outdoors',
                        },
                    },
                ]
            },
            {
                path: '/outdoors/campaigns',
                name: 'outdoorsCampaigns',
                component: OutdoorsCampaigns,
                meta: {
                    title: 'Outdoors / Kampanie',
                    menuRendered: true,
                    menuTitle: 'Kampanie',
                    requiresAuth: true,
                    permission: 'outdoors',
                },
                redirect: { name: 'outdoorsCampaignsCampaigns' },
                children: [
                    {
                        path: '/outdoors/campaigns/outdoors-campaigns',
                        name: 'outdoorsCampaignsCampaigns',
                        component: OutdoorsCampaignsCampaigns,
                        meta: {
                            title: 'Outdoors / Kampanie / Lista kampanii',
                            requiresAuth: true,
                            permission: 'outdoors',
                        },
                    },
                    {
                        path: '/outdoors/campaigns/outdoors-campaigns/create',
                        name: 'outdoorsCampaignsCampaignsOutdoorsCampaignCreate',
                        component: OutdoorsCampaignsCampaignsOutdoorsCampaign,
                        meta: {
                            title: 'Outdoors / Kampanie / Kampania',
                            requiresAuth: true,
                            permission:  'outdoors_create'
                        },
                    },
                    {
                        path: '/outdoors/campaigns/outdoors-campaigns/edit/:id',
                        name: 'outdoorsCampaignsCampaignsOutdoorsCampaignEdit',
                        component: OutdoorsCampaignsCampaignsOutdoorsCampaign,
                        meta: {
                            title: 'Outdoors / Kampanie / Kampania',
                            requiresAuth: true,
                            permission:  'outdoors_read'
                        },
                    },
                    {
                        path: '/outdoors/campaigns/outdoors-campaigns/create/add-product',
                        name: 'outdoorsCampaignsCampaignsProductAddProduct',
                        component: OutdoorsCampaignsCampaignsProduct,
                        meta: {
                            title: 'Outdoors / Kampanie / Kampania / Dodawanie produktu',
                            requiresAuth: true,
                            permission: 'outdoors_create',
                        },
                    },
                    {
                        path: '/outdoors/campaigns/outdoors-campaigns/create/edit-product',
                        name: 'outdoorsCampaignsCampaignsProductEditProduct',
                        component: OutdoorsCampaignsCampaignsProduct,
                        meta: {
                            title: 'Outdoors / Kampanie / Kampania / Edycja produktu',
                            requiresAuth: true,
                            permission: 'outdoors_create',
                        },
                    },
                ],
            },
            {
                path: '/outdoors/map',
                name: 'outdoorsMap',
                component: OutdoorsMap,
                meta: {
                    title: 'Outdoors / Mapa',
                    menuRendered: true,
                    menuTitle: 'Mapa',
                    requiresAuth: true,
                    permission: 'outdoors',
                },
            }
        ]
    },
]